export * from './contentpage.module';
export * from './contentpage.routes';